import React, { useEffect, useMemo, useCallback } from 'react'
import {
  Box,
  Layer,
  IcoMoon,
  useResponsiveWrapperContext,
  CloseIcon,
} from '@usap/uicomponents'

import { BoxWithPointer } from '@usap/widgets'
import useIsMounted from '../../../../../../hooks/useIsMounted'

const PopUpBox = props => {
  const {
    children,
    showPopup = false,
    isFullScreen = false,
    shouldShowPopup,
  } = props

  const isMounted = useIsMounted()
  const { size } = useResponsiveWrapperContext()

  useEffect(() => {
    if (__BROWSER__ && isMounted()) {
      if (showPopup) document.body.classList.add('overflowHidden')
      else document.body.classList.remove('overflowHidden')
    }
  }, [showPopup, isMounted])

  const style = useMemo(
    () => {
      const iconRight = -4
      const iconTop = size === 'small' ? -4 : -32
      const iconColor = size === 'small' ? '#999999' : 'white'

      return {
        layer: {
          zIndex: 1000,
          overflowScrolling: 'touch',
          WebkitOverflowScrolling: 'touch',
        },
        iconWrapper: {
          position: 'absolute',
          right: iconRight,
          top: iconTop,
        },
        iconColor,
      }
    },
    [size],
  )

  const handleClose = useCallback(
    () => {
      shouldShowPopup(false)
    },
    [shouldShowPopup],
  )

  return (
    <Box animation={showPopup ? 'fadeIn' : 'fadeOut'}>
      {showPopup && (
        <Layer
          margin={isFullScreen ? '0px' : 'small'}
          responsive={false}
          animation="fadeIn"
          full={isFullScreen}
          style={style.layer}
          onEsc={handleClose}
          onClickOutside={handleClose}
        >
          {children}

          <Box
            style={style.iconWrapper}
          >
            <BoxWithPointer align="center">
              <IcoMoon
                icon={CloseIcon}
                size="36px"
                color={style.iconColor}
                onClick={handleClose}
              />
            </BoxWithPointer>
          </Box>
        </Layer>
      )}
    </Box>
  )
}

export default PopUpBox
